var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('h2',[_vm._v(" English Premier League ")]),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.teams,"fields":_vm.fields},on:{"row-clicked":_vm.details}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }